import { createSelector } from 'reselect';

const key = 'subscribe';
const domains = {
    email: (state) => state.global[key].email,
    isLoading: (state) => state.global[key].isLoading,
    isError: (state) => state.global[key].isError,
    isAlready: (state) => state.global[key].isAlready,
    errorMessage: (state) => state.global[key].errorMessage,
};

const selectorEmail = createSelector([domains.email], (email) => email);

const selectorIsLoading = createSelector([domains.isLoading], (isLoading) => isLoading);

const selectorIsError = createSelector([domains.isError], (isError) => isError);

const selectorIsAlready = createSelector([domains.isAlready], (isAlready) => isAlready);

const selectorErrorMessage = createSelector([domains.errorMessage], (errorMessage) => errorMessage);

const makeSelectEmail = () => selectorEmail;
const makeSelectIsLoading = () => selectorIsLoading;
const makeSelectIsError = () => selectorIsError;
const makeSelectIsAlready = () => selectorIsAlready;
const makeSelectErrorMessage = () => selectorErrorMessage;

export {
    makeSelectEmail,
    makeSelectIsLoading,
    makeSelectIsError,
    makeSelectIsAlready,
    makeSelectErrorMessage,
};
